(function() {
  if (window.btLedQuickAddInitialized) return;
  window.btLedQuickAddInitialized = true;

  var formSelector = '.bt-led-feature__form';

  function variantIsAvailable(form) {
    var variantField = form.querySelector('[data-led-variant]');
    if (!variantField) return false;

    if (variantField instanceof HTMLSelectElement) {
      var option = variantField.options[variantField.selectedIndex];
      return Boolean(option && option.dataset.available === 'true');
    }

    return variantField.dataset.available === 'true';
  }

  document.addEventListener('change', function(event) {
    var field = event.target;
    if (!(field instanceof HTMLSelectElement) || !field.matches(formSelector + ' [data-led-variant]')) return;

    var form = field.form;
    var option = field.options[field.selectedIndex];
    var price = form.parentElement.querySelector('[data-led-price]');
    var button = form.querySelector('[data-add-to-cart]');
    var label = button && button.querySelector('[data-add-to-cart-text]');
    var available = Boolean(option && option.dataset.available === 'true');

    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = !available;
      if (label) label.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
    }

    var status = form.querySelector('[data-led-status]');
    if (status) status.textContent = '';
  });

  document.addEventListener('submit', async function(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;

    event.preventDefault();
    if (form.dataset.submitting === 'true') return;

    var button = form.querySelector('[data-add-to-cart]');
    if (!button || button.disabled) return;

    var variantField = form.querySelector('[data-led-variant]');
    var status = form.querySelector('[data-led-status]');
    var label = button.querySelector('[data-add-to-cart-text]');
    var variantWasDisabled = variantField ? variantField.disabled : false;

    form.dataset.submitting = 'true';
    button.disabled = true;
    button.classList.add('btn--loading');
    button.setAttribute('aria-busy', 'true');
    if (variantField instanceof HTMLSelectElement) variantField.disabled = true;
    if (status) status.textContent = 'Legger i handlekurven.';

    try {
      var endpoint = form.action.endsWith('.js') ? form.action : form.action + '.js';
      var response = await fetch(endpoint, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      var product = await response.json();

      if (!response.ok || product.status) {
        throw new Error(product.description || product.message || 'Kunne ikke legge produktet i handlekurven. Prøv igjen.');
      }

      if (status) status.textContent = 'Lagt i handlekurven.';
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: button
        },
        bubbles: true
      }));
    } catch (error) {
      var message = error.message || 'Kunne ikke legge produktet i handlekurven. Prøv igjen.';
      if (status) status.textContent = message;
      form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: message
        },
        bubbles: true
      }));
    } finally {
      delete form.dataset.submitting;
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
      if (variantField instanceof HTMLSelectElement) variantField.disabled = variantWasDisabled;
      button.disabled = !variantIsAvailable(form);
      var currentOption = variantField instanceof HTMLSelectElement ? variantField.options[variantField.selectedIndex] : null;
      if (label) label.textContent = currentOption && currentOption.dataset.available !== 'true' ? button.dataset.unavailableLabel : button.dataset.availableLabel;
    }
  });
})();
